module.exports = __webpack_public_path__ + "static/media/cpp.57fa14ba.png";